import CreateLectureVouchers from '../../features/dashboard/lectureVouchers/CreateLectureVouchers';

function LectureVouchersDB() {
    return <CreateLectureVouchers />
}

export default LectureVouchersDB